/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_User_Is_BlockedInputs */

const nl_auth_api_errors_user_is_blocked = /** @type {(inputs: Auth_Api_Errors_User_Is_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit account is geblokkeerd`)
};

/**

* @param {Auth_Api_Errors_User_Is_BlockedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_user_is_blocked = /** @type {((inputs?: Auth_Api_Errors_User_Is_BlockedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_User_Is_BlockedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_user_is_blocked(inputs)
});
export { auth_api_errors_user_is_blocked as "auth.api_errors.user_is_blocked" }